import React from "react";
import "./PatrolQc.css";
import { usePatrolQc, TROUBLE_TYPES } from "./usePatrolQc.js";
import moment from "moment";
import { getTime } from "../../util/formatDate.js";
import { hasRole } from "../../util/utilFunction";

const SHIFTS = ["1", "2", "3"];

const PatrolQc = () => {
  const {
    dataUser,
    subMenu,
    setSubMenu,
    errMsg,
    successMsg,
    isScanning,
    stopScanner,
    sortedMesin,
    shiftPatrol,
    setShiftPatrol,
    mesinPick,
    setMesinPick,
    hasTrouble,
    toggleTrouble,
    troubleType,
    setTroubleType,
    troubleDesc,
    setTroubleDesc,
    handlePickLaporan,
    handleSubMenuHistoryPatrol,
    historyRows,
    summary,
    shiftHistoryPatrol,
    setShiftHistoryPatrol,
    mesinPatrol,
    setMesinPatrol,
    datePatrolQc,
    setDatePatrolQc,
    onlyTrouble,
    setOnlyTrouble,
    resetHistoryFilter,
    isFilterChanged,
  } = usePatrolQc();

  const canSeeHistory = hasRole(
    dataUser,
    "super_user",
    "qc_admin",
    "qc_user",
    "ppic_admin"
  );

  return (
    <div className="container_inventory patrol">
      <p className="title_inventory">Patrol Checker</p>

      {canSeeHistory && (
        <div className="patrol_tabs">
          <button
            type="button"
            className={
              subMenu === "patrol" ? "patrol_tab active" : "patrol_tab"
            }
            onClick={() => setSubMenu("patrol")}
          >
            Patrol
          </button>
          <button
            type="button"
            className={
              subMenu === "history" ? "patrol_tab active" : "patrol_tab"
            }
            onClick={handleSubMenuHistoryPatrol}
          >
            History
          </button>
        </div>
      )}

      {subMenu === "patrol" ? (
        <div className="patrol_card">
          {/* Langkah 1: shift & mesin */}
          <div className="patrol_step">
            <span className="patrol_step_no">1</span>
            <span className="patrol_step_title">Pilih Shift &amp; Mesin</span>
          </div>

          <div className="patrol_chips">
            {SHIFTS.map((s) => (
              <button
                type="button"
                key={s}
                className={shiftPatrol === s ? "chip active" : "chip"}
                onClick={() => setShiftPatrol(s)}
              >
                Shift {s}
              </button>
            ))}
          </div>

          <select
            className="patrol_input"
            value={mesinPick}
            onChange={(e) => setMesinPick(e.target.value)}
          >
            <option value="" disabled>
              Pilih nomor mesin
            </option>
            {sortedMesin.map((m) => (
              <option key={m.id_mesin} value={m.id_mesin}>
                Mesin {m.mesin}
              </option>
            ))}
          </select>

          {/* Langkah 2: kondisi */}
          <div className="patrol_step">
            <span className="patrol_step_no">2</span>
            <span className="patrol_step_title">Kondisi Mesin</span>
          </div>

          <div className="patrol_condition">
            <button
              type="button"
              className={!hasTrouble ? "cond cond_ok active" : "cond cond_ok"}
              onClick={() => toggleTrouble(false)}
            >
              <span className="cond_icon">✓</span>
              Normal
            </button>
            <button
              type="button"
              className={
                hasTrouble ? "cond cond_trouble active" : "cond cond_trouble"
              }
              onClick={() => toggleTrouble(true)}
            >
              <span className="cond_icon">!</span>
              Ada Trouble
            </button>
          </div>

          {hasTrouble && (
            <div className="trouble_box">
              <p className="patrol_label">Jenis Trouble</p>
              <div className="patrol_chips wrap">
                {TROUBLE_TYPES.map((t) => (
                  <button
                    type="button"
                    key={t}
                    className={
                      troubleType === t
                        ? "chip chip_trouble active"
                        : "chip chip_trouble"
                    }
                    onClick={() => setTroubleType(t)}
                  >
                    {t}
                  </button>
                ))}
              </div>
              <p className="patrol_label">Keterangan</p>
              <textarea
                className="patrol_textarea"
                placeholder="Jelaskan trouble / kondisi produk yang ditemukan"
                value={troubleDesc}
                onChange={(e) => setTroubleDesc(e.target.value)}
              />
            </div>
          )}

          {/* Langkah 3: scan */}
          <div className="patrol_step">
            <span className="patrol_step_no">3</span>
            <span className="patrol_step_title">Scan QR Mesin</span>
          </div>

          {errMsg && <p className="patrol_alert error">{errMsg}</p>}
          {successMsg && <p className="patrol_alert success">{successMsg}</p>}

          <div
            id="patrol"
            className={isScanning ? "patrol_scanner show" : "patrol_scanner"}
          />

          {isScanning ? (
            <button
              type="button"
              className="patrol_btn secondary"
              onClick={stopScanner}
            >
              Batal Scan
            </button>
          ) : (
            <button
              type="button"
              className={hasTrouble ? "patrol_btn danger" : "patrol_btn"}
              onClick={handlePickLaporan}
            >
              {hasTrouble
                ? "Scan & Simpan dengan Flag Trouble"
                : "Scan & Simpan"}
            </button>
          )}
        </div>
      ) : (
        <>
          <div className="history_filter">
            <div className="patrol_chips">
              <button
                type="button"
                className={shiftHistoryPatrol === "" ? "chip active" : "chip"}
                onClick={() => setShiftHistoryPatrol("")}
              >
                Semua
              </button>
              {SHIFTS.map((s) => (
                <button
                  type="button"
                  key={s}
                  className={shiftHistoryPatrol === s ? "chip active" : "chip"}
                  onClick={() => setShiftHistoryPatrol(s)}
                >
                  Shift {s}
                </button>
              ))}
            </div>
            <div className="history_row">
              <select
                className="patrol_input"
                value={mesinPatrol}
                onChange={(e) => setMesinPatrol(e.target.value)}
              >
                <option value="">Semua mesin</option>
                {sortedMesin.map((m) => (
                  <option key={m.id_mesin} value={m.mesin}>
                    Mesin {m.mesin}
                  </option>
                ))}
              </select>
              <input
                type="date"
                className="patrol_input"
                value={datePatrolQc}
                onChange={(e) => setDatePatrolQc(e.target.value)}
              />
            </div>
            <div className="history_footer">
              <label className="history_toggle">
                <input
                  type="checkbox"
                  checked={onlyTrouble}
                  onChange={(e) => setOnlyTrouble(e.target.checked)}
                />
                Tampilkan hanya yang trouble
              </label>
              <button
                type="button"
                className="history_reset"
                onClick={resetHistoryFilter}
                disabled={!isFilterChanged}
              >
                ↺ Reset
              </button>
            </div>
          </div>

          <div className="history_summary">
            <div className="sum_box">
              <b>{summary.total}</b>
              <span>Total patrol</span>
            </div>
            <div className="sum_box sum_trouble">
              <b>{summary.trouble}</b>
              <span>Trouble</span>
            </div>
          </div>

          <div className="history_list">
            {historyRows.length === 0 && (
              <p className="history_empty">Belum ada data patrol.</p>
            )}
            {historyRows.map((row, i) => {
              const trouble = row.isTrouble === true;
              return (
                <div
                  key={`${row.timestamp}-${row.mesin}-${i}`}
                  className={trouble ? "h_card h_trouble" : "h_card"}
                >
                  <div className="h_top">
                    <span className="h_mesin">Mesin {row.mesin}</span>
                    {trouble ? (
                      <span className="badge badge_trouble">⚑ Trouble</span>
                    ) : (
                      <span className="badge badge_ok">Normal</span>
                    )}
                  </div>
                  {(row.moldType || row.mold) && (
                    <p className="h_mold">{row.moldType || row.mold}</p>
                  )}
                  <div className="h_meta">
                    <span>{row.name}</span>
                    <span>Shift {row.shift}</span>
                    <span>
                      {moment(row.timestamp)
                        .utcOffset("+0700")
                        .format("DD-MM-YYYY")}{" "}
                      · {getTime(row.timestamp)}
                    </span>
                  </div>
                  {trouble ? (
                    <div className="h_trouble_detail">
                      {row.troubleType && <b>{row.troubleType}</b>}
                      {row.troubleDesc && <p>{row.troubleDesc}</p>}
                    </div>
                  ) : (
                    row.troubleDesc && (
                      <p className="h_note">{row.troubleDesc}</p>
                    )
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default PatrolQc;
